import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pr0010',
    ecrans: ['00-2']
});
